module.exports = __webpack_public_path__ + "static/media/Russell Road Kitchen (5).37bab5a6.jpg";